<template>
  <div class="loading">
    <div class="loading-point" />
  </div>
</template>
<script>

export default {
}
</script>
<style lang="scss" scoped>
  // @function rem($n) {
  //   @return $n / 100 * 1rem;
  // }
  $wh: 9; // 圆点宽高
  $dis: 10; // 圆点间距

  @mixin point-style {
    display: block;
    width: #{$wh}px;
    height: #{$wh}px;
    border-radius: 50%;
    background-color: rgba(255, 173, 60, 1);
    animation: loading-point 0.6s infinite ease-in-out;
  }
  .loading{
    z-index: 998;
    position: fixed;
    top: 0;
    left: 0;
    background: transparent;
    width: 100vw;
    height: 100vh;
  }
  .loading-point {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    @include point-style;
    transform: translateX(-#{$wh + $dis}px);

    &::after {
      content: " ";
      @include point-style;
      position: absolute;
      right: -#{$wh + $dis}px;
      top: 0;
      animation-delay: 0.2s;
    }

    &::before {
      content: " ";
      @include point-style;
      position: absolute;
      right: -#{$wh + $dis + $wh + $dis}px;
      top: 0;
      animation-delay: 0.4s;
    }
  }

  @keyframes loading-point {
    0% {
      background-color: rgba(255, 173, 60, 1);
    }
    100% {
      background-color: rgba(255, 173, 60, 0.3);
    }
  }
</style>
